import React from 'react';
import PropTypes from 'prop-types';

import IMAGES from 'modules/assets/web';

const OnboardingFooter = props => {
  const {
    isHiddenSidebar,
    toggleSidebar,
    navigateToStep,
    isCompletedStep,
  } = props;
  const renderStep = (stepName, stepNumber) => (
    <li
      className={`step-item${isCompletedStep(stepNumber + 1)}`}
      key={stepName}
    >
      <a onClick={() => navigateToStep(stepNumber + 1)}>
        {stepNumber + 1}
        <span>: {stepName}</span>
      </a>
    </li>
  );

  const steps = [
    'Basics',
    'About You',
    'Change',
    'Fitness',
    'Nutrition',
    'Mindset',
    'Finish',
  ];

  return (
    <div className="page--footer p-0 show-sidebar">
      <ul className="onboarding-step-bar d-flex bg-info text-white p-0">
        <li className="logo text-center bg-primary">
          <a onClick={() => toggleSidebar()}>
            <img alt="footer-logo" src={IMAGES.LOGO_WHITE} />
          </a>
        </li>
        {steps.map((item, index) => renderStep(item, index))}
      </ul>
    </div>
  );
};

OnboardingFooter.propTypes = {
  isHiddenSidebar: PropTypes.bool,
  toggleSidebar: PropTypes.func.isRequired,
  navigateToStep: PropTypes.func.isRequired,
  isCompletedStep: PropTypes.func.isRequired,
};

OnboardingFooter.defaultProps = {
  isHiddenSidebar: false,
};

export default OnboardingFooter;
